/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkBuildingservice } from '../models/work-buildingservice';
import { WorkCalculationBuildingserviceEntriesDto } from '../models/work-calculation-buildingservice-entries-dto';
import { WorkCreateBuildingserviceDto } from '../models/work-create-buildingservice-dto';
import { WorkDropdownOptionDto } from '../models/work-dropdown-option-dto';
import { WorkPaginatedDocumented } from '../models/work-paginated-documented';
import { WorkUpdateBuildingserviceDto } from '../models/work-update-buildingservice-dto';
import { WorkUpdateCalculationBuildingserviceEntriesDto } from '../models/work-update-calculation-buildingservice-entries-dto';

@Injectable({ providedIn: 'root' })
export class WorkBuildingservicesV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `buildingservicesV2ControllerFindForCalculationId()` */
  static readonly BuildingservicesV2ControllerFindForCalculationIdPath = '/v2/buildingservices/calculation/{calculationId}';

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `buildingservicesV2ControllerFindForCalculationId()` instead.
   *
   * This method doesn't expect any request body.
   */
  buildingservicesV2ControllerFindForCalculationId$Response(
    params: {
      calculationId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkCalculationBuildingserviceEntriesDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkBuildingservicesV2Service.BuildingservicesV2ControllerFindForCalculationIdPath, 'get');
    if (params) {
      rb.path('calculationId', params.calculationId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkCalculationBuildingserviceEntriesDto>;
      })
    );
  }

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `buildingservicesV2ControllerFindForCalculationId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  buildingservicesV2ControllerFindForCalculationId(
    params: {
      calculationId: number;
    },
    context?: HttpContext
  ): Observable<WorkCalculationBuildingserviceEntriesDto> {
    return this.buildingservicesV2ControllerFindForCalculationId$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkCalculationBuildingserviceEntriesDto>): WorkCalculationBuildingserviceEntriesDto => r.body)
    );
  }

  /** Path part for operation `buildingservicesV2ControllerUpdateForCalculationId()` */
  static readonly BuildingservicesV2ControllerUpdateForCalculationIdPath = '/v2/buildingservices/calculation/{calculationId}';

  /**
   * Required permissions: projects:update, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `buildingservicesV2ControllerUpdateForCalculationId()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  buildingservicesV2ControllerUpdateForCalculationId$Response(
    params: {
      calculationId: number;
      body: WorkUpdateCalculationBuildingserviceEntriesDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkCalculationBuildingserviceEntriesDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkBuildingservicesV2Service.BuildingservicesV2ControllerUpdateForCalculationIdPath, 'patch');
    if (params) {
      rb.path('calculationId', params.calculationId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkCalculationBuildingserviceEntriesDto>;
      })
    );
  }

  /**
   * Required permissions: projects:update, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `buildingservicesV2ControllerUpdateForCalculationId$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  buildingservicesV2ControllerUpdateForCalculationId(
    params: {
      calculationId: number;
      body: WorkUpdateCalculationBuildingserviceEntriesDto
    },
    context?: HttpContext
  ): Observable<WorkCalculationBuildingserviceEntriesDto> {
    return this.buildingservicesV2ControllerUpdateForCalculationId$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkCalculationBuildingserviceEntriesDto>): WorkCalculationBuildingserviceEntriesDto => r.body)
    );
  }

  /** Path part for operation `buildingservicesV2ControllerFindAllActive()` */
  static readonly BuildingservicesV2ControllerFindAllActivePath = '/v2/buildingservices/active';

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `buildingservicesV2ControllerFindAllActive()` instead.
   *
   * This method doesn't expect any request body.
   */
  buildingservicesV2ControllerFindAllActive$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkBuildingservice>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkBuildingservicesV2Service.BuildingservicesV2ControllerFindAllActivePath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkBuildingservice>>;
      })
    );
  }

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `buildingservicesV2ControllerFindAllActive$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  buildingservicesV2ControllerFindAllActive(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkBuildingservice>> {
    return this.buildingservicesV2ControllerFindAllActive$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkBuildingservice>>): Array<WorkBuildingservice> => r.body)
    );
  }

  /** Path part for operation `buildingservicesV2ControllerGetAllDropdownOptions()` */
  static readonly BuildingservicesV2ControllerGetAllDropdownOptionsPath = '/v2/buildingservices/dropdown-options';

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `buildingservicesV2ControllerGetAllDropdownOptions()` instead.
   *
   * This method doesn't expect any request body.
   */
  buildingservicesV2ControllerGetAllDropdownOptions$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkDropdownOptionDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkBuildingservicesV2Service.BuildingservicesV2ControllerGetAllDropdownOptionsPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkDropdownOptionDto>>;
      })
    );
  }

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `buildingservicesV2ControllerGetAllDropdownOptions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  buildingservicesV2ControllerGetAllDropdownOptions(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkDropdownOptionDto>> {
    return this.buildingservicesV2ControllerGetAllDropdownOptions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkDropdownOptionDto>>): Array<WorkDropdownOptionDto> => r.body)
    );
  }

  /** Path part for operation `buildingservicesV2ControllerFindAllPaginated()` */
  static readonly BuildingservicesV2ControllerFindAllPaginatedPath = '/v2/buildingservices';

  /**
   * Required permissions: buildingservice:read, buildingservice:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `buildingservicesV2ControllerFindAllPaginated()` instead.
   *
   * This method doesn't expect any request body.
   */
  buildingservicesV2ControllerFindAllPaginated$Response(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 50
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 200
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> name:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li>
     * <li>name</li>
     * <li>shortname</li>
     * <li>active</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC' | 'name:ASC' | 'name:DESC' | 'shortname:ASC' | 'shortname:DESC' | 'active:ASC' | 'active:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> name,shortname
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>name</li>
     * <li>shortname</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkBuildingservice>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkBuildingservicesV2Service.BuildingservicesV2ControllerFindAllPaginatedPath, 'get');
    if (params) {
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('sortBy', params.sortBy, {});
      rb.query('search', params.search, {});
      rb.query('searchBy', params.searchBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkBuildingservice>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: buildingservice:read, buildingservice:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `buildingservicesV2ControllerFindAllPaginated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  buildingservicesV2ControllerFindAllPaginated(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 50
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 200
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> name:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li>
     * <li>name</li>
     * <li>shortname</li>
     * <li>active</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC' | 'name:ASC' | 'name:DESC' | 'shortname:ASC' | 'shortname:DESC' | 'active:ASC' | 'active:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> name,shortname
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>name</li>
     * <li>shortname</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkBuildingservice>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
};
};
}> {
    return this.buildingservicesV2ControllerFindAllPaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkBuildingservice>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkBuildingservice>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
};
};
} => r.body)
    );
  }

  /** Path part for operation `buildingservicesV2ControllerCreate()` */
  static readonly BuildingservicesV2ControllerCreatePath = '/v2/buildingservices';

  /**
   * Required permissions: buildingservice:create, buildingservice:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `buildingservicesV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  buildingservicesV2ControllerCreate$Response(
    params: {
      body: WorkCreateBuildingserviceDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkBuildingservice>> {
    const rb = new RequestBuilder(this.rootUrl, WorkBuildingservicesV2Service.BuildingservicesV2ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkBuildingservice>;
      })
    );
  }

  /**
   * Required permissions: buildingservice:create, buildingservice:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `buildingservicesV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  buildingservicesV2ControllerCreate(
    params: {
      body: WorkCreateBuildingserviceDto
    },
    context?: HttpContext
  ): Observable<WorkBuildingservice> {
    return this.buildingservicesV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkBuildingservice>): WorkBuildingservice => r.body)
    );
  }

  /** Path part for operation `buildingservicesV2ControllerFindOneById()` */
  static readonly BuildingservicesV2ControllerFindOneByIdPath = '/v2/buildingservices/{id}';

  /**
   * Required permissions: buildingservice:read, buildingservice:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `buildingservicesV2ControllerFindOneById()` instead.
   *
   * This method doesn't expect any request body.
   */
  buildingservicesV2ControllerFindOneById$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkBuildingservice>> {
    const rb = new RequestBuilder(this.rootUrl, WorkBuildingservicesV2Service.BuildingservicesV2ControllerFindOneByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkBuildingservice>;
      })
    );
  }

  /**
   * Required permissions: buildingservice:read, buildingservice:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `buildingservicesV2ControllerFindOneById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  buildingservicesV2ControllerFindOneById(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkBuildingservice> {
    return this.buildingservicesV2ControllerFindOneById$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkBuildingservice>): WorkBuildingservice => r.body)
    );
  }

  /** Path part for operation `buildingservicesV2ControllerDeactivate()` */
  static readonly BuildingservicesV2ControllerDeactivatePath = '/v2/buildingservices/{id}';

  /**
   * Required permissions: buildingservice:delete, buildingservice:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `buildingservicesV2ControllerDeactivate()` instead.
   *
   * This method doesn't expect any request body.
   */
  buildingservicesV2ControllerDeactivate$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkBuildingservice>> {
    const rb = new RequestBuilder(this.rootUrl, WorkBuildingservicesV2Service.BuildingservicesV2ControllerDeactivatePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkBuildingservice>;
      })
    );
  }

  /**
   * Required permissions: buildingservice:delete, buildingservice:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `buildingservicesV2ControllerDeactivate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  buildingservicesV2ControllerDeactivate(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkBuildingservice> {
    return this.buildingservicesV2ControllerDeactivate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkBuildingservice>): WorkBuildingservice => r.body)
    );
  }

  /** Path part for operation `buildingservicesV2ControllerUpdate()` */
  static readonly BuildingservicesV2ControllerUpdatePath = '/v2/buildingservices/{id}';

  /**
   * Required permissions: buildingservice:update, buildingservice:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `buildingservicesV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  buildingservicesV2ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdateBuildingserviceDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkBuildingservice>> {
    const rb = new RequestBuilder(this.rootUrl, WorkBuildingservicesV2Service.BuildingservicesV2ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkBuildingservice>;
      })
    );
  }

  /**
   * Required permissions: buildingservice:update, buildingservice:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `buildingservicesV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  buildingservicesV2ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdateBuildingserviceDto
    },
    context?: HttpContext
  ): Observable<WorkBuildingservice> {
    return this.buildingservicesV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkBuildingservice>): WorkBuildingservice => r.body)
    );
  }

}
